/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Ellipses_Replacement_FailedInputs */



/**
* | output |
* | --- |
* | "Ellipses replacement failed. {error}" |
*
* @param {Ellipses_Replacement_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ellipses_replacement_failed = /** @type {((inputs: Ellipses_Replacement_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ellipses_Replacement_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Remplacement par les points de suspension échoué. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Austausch der Ellipsen ist fehlgeschlagen. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sostituzione delle ellissi non riuscita. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Замена эллипсов не удалась. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error en el reemplazo de elipses. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`省略号替换失败。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`省略記号の置換に失敗しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`दीर्घवृत्त प्रतिस्थापन विफल रहा। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A substituição das elipses falhou. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Ellipses replacement failed. ${i?.error}`)
});